import {
  IVetHorseDetailsPageActions,
  SET_IS_ADD_CUSTOM_RISK_POPUP_OPEN,
  SET_MAP_POPUP_STATE,
  SET_RISK_CANDIDATE_FOR_DELETION
} from "store/actions/vetHorseDetailsPage";
import { IVetHorseDetailsPageState } from "interfaces/VetHorseDetailsPageState";

const initialState: IVetHorseDetailsPageState = {
  mapPopupState: false,
  isAddCustomRiskPopupOpen: false,
  riskCandidateForDeletion: null
};

export default (
  state: IVetHorseDetailsPageState = initialState,
  action: IVetHorseDetailsPageActions
): IVetHorseDetailsPageState => {
  switch (action.type) {
    case SET_MAP_POPUP_STATE:
      return {
        ...state,
        mapPopupState: action.mapPopupState
      };
    case SET_IS_ADD_CUSTOM_RISK_POPUP_OPEN:
      return {
        ...state,
        isAddCustomRiskPopupOpen: action.isAddCustomRiskPopupOpen
      };
    case SET_RISK_CANDIDATE_FOR_DELETION:
      return {
        ...state,
        riskCandidateForDeletion: action.riskCandidateForDeletion
      };
    default:
      return state;
  }
};
